// extracted by mini-css-extract-plugin
export var bottomRightDock = "_12-0";